import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

const ReadyToServe = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="border-2 rounded-lg p-8 md:p-12 relative"
          style={{ borderColor: '#1A1A1A' }}
        >
          <div className="space-y-6 mb-8">
            <h2 
              className="text-4xl md:text-5xl font-bold"
              style={{ color: '#1A1A1A' }}
            >
              Ready to Serve You
            </h2>
            <p 
              className="text-lg leading-relaxed"
              style={{ color: '#555555' }}
            >
              NamoriSatya Legal is committed to providing expert legal 
              representation tailored to your specific needs. Reach out today for 
              a free initial consultation.
            </p>
            <p 
              className="text-lg leading-relaxed"
              style={{ color: '#555555' }}
            >
              Available Monday to Saturday, 5:00 PM to 10:00 PM. 
              Contact us at officenamorisatyalegal@gmail.com
            </p>
          </div>

          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="https://customer-assets.emergentagent.com/job_5ecb04eb-657f-4ef6-b290-78fd64f7315c/artifacts/hwcl5mjy_rupam-photo.jpg"
                alt="Rupam Kumari"
                className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-md"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_5ecb04eb-657f-4ef6-b290-78fd64f7315c/artifacts/d5wgk07c_abhyant-photo.png"
                alt="Abhyant Patel"
                className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-md -ml-4"
              />
            </div>
            <Button
              onClick={scrollToContact}
              className="text-base font-semibold px-8 py-6 transition-all duration-300 hover:opacity-90"
              style={{ backgroundColor: '#2B2BFF', color: 'white' }}
            >
              Contact Us →
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ReadyToServe;